import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const eventDeleteApi = createAsyncThunk(
  "eventModule/delete",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.delete(apiRoutes.publicapiAction(`events`, 1), { data });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const eventDeleteSlice = createSlice({
  name: "event delete",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(eventDeleteApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(eventDeleteApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(eventDeleteApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const eventDeleteReducer = eventDeleteSlice.reducer;
